import { ConfigReportComboApi } from "go-report-combo/User/services/types";

export const REPORT_cs_feature_name_kpi = {
	id: "REPORT_cs_feature_name_kpi",
	name: "KPI CS Funkcje po nazwie - upgrade / downgrade",
	data: [
		{
			id: "FEATURE_FIRST_USAGE",
			resource: "ORGANIZATION_FEATURE_USAGE",
			filter: "partner_type|e=CSçusage_type|e=MONTHLY",
			groups: ["NONE", "NAME"],
			columns: [
				{
					id: "summary",
					filter: "date_year_month|bt={date_range__QUARTER}",
				},
				{
					id: "monthly",
					group: "DATE_MONTH",
					filter: "date_year_month|bt={date_range__QUARTER}",
				},
			],
		},
	],
	table: [
		{
			id: "features_downgrade_upgrade",
			name: "Funkcje - upgrade/downgrade",
			rows: [
				{
					id: "products",
					name: "products",
					data_id: "FEATURE_FIRST_USAGE",
					group: "NAME",
					aggregate: "downgrade_usage_points",
					aggregate_columns: {
						features_downgrade_upgrade: "upgrade_usage_count + downgrade_usage_count",
						features_downgrade_upgrade_monthly: "upgrade_usage_count + downgrade_usage_count",
						features_downgrade_upgrade_points_monthly: "upgrade_usage_points + downgrade_usage_points",
						features_downgrade_upgrade_points: "upgrade_usage_points + downgrade_usage_points",
					},
					compare: [
						{
							id: "upgrade",
							data_id: "FEATURE_FIRST_USAGE",
							name: "Upgrade",
							format: "VALUE",
							aggregate: "upgrade_usage_count",
							aggregate_columns: {
								features_downgrade_upgrade: "upgrade_usage_count",
								features_downgrade_upgrade_monthly: "upgrade_usage_count",
								features_downgrade_upgrade_points: "upgrade_usage_points",
								features_downgrade_upgrade_points_monthly: "upgrade_usage_points",
							},
						},
						{
							id: "downgrade",
							data_id: "FEATURE_FIRST_USAGE",
							name: "Downgrade",
							format: "VALUE",
							aggregate: "downgrade_usage_count",
							aggregate_columns: {
								features_downgrade_upgrade: "downgrade_usage_count",
								features_downgrade_upgrade_monthly: "downgrade_usage_count",
								features_downgrade_upgrade_points: "downgrade_usage_points",
								features_downgrade_upgrade_points_monthly: "downgrade_usage_points",
							},
						},
					],
				},
			],
			columns: [
				{
					id: "features_downgrade_upgrade",
					data_column_id: "summary",
					name: "Fukcje",
				},
				{
					id: "features_downgrade_upgrade_monthly",
					data_column_id: "monthly",
					name: "Fukcje",
					values_dynamic: "values_previous_3_months",
				},
				{
					id: "features_downgrade_upgrade_points",
					data_column_id: "summary",
					name: "Punkty",
				},
				{
					id: "features_downgrade_upgrade_points_monthly",
					data_column_id: "monthly",
					name: "Punkty",
					values_dynamic: "values_previous_3_months",
				},
			],
		},
	],
} as ConfigReportComboApi;
